import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { AccountPackagesComponent } from '../account-packages/account-packages.component';
import { Constants } from '../constants/constants';
import { EnrollmentConstants } from '../constants/enrollment-constants';
import { MessageConstants } from '../constants/message-constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';
import { VehicleService } from '../service/vehicle.service';

const PAGE_SIZE: number = 50;

@Component({
  selector: 'app-enroll-vehicles',
  templateUrl: './enroll-vehicles.component.html',
  styleUrls: ['./enroll-vehicles.component.scss']
})
export class EnrollVehicleComponent implements OnInit {

  @Input() account;
  @Output() saveEmitter: EventEmitter<any> = new EventEmitter<any>();

  vehicleList: any = [];
  selectedVehicles: Array<any> = [];
  //Filters
  vehicleFilters: any = {};
  //Pagination variables
  previousPage: number;
  nextPage: number;

  buttonText: string;
  headerText: string;

  selectedPackages;
  enrollmentErrors = [];

  @ViewChild('accountPackageModal') accountPackageModal: AccountPackagesComponent;

  isEnrollWindow = true;
  reviewVehicleModalMessages = { header: "", message: "" }
  searchKey = null;
  backupVehicleList = [];

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService,
    private toastService: ToastService, private vehicleService: VehicleService) { }

  ngOnInit(): void {

  }

  // 
  /* initFilters() {
    this.vehicleFilters = {
      "enrollmentEligibility": true,
      "status": EnrollmentConstants.ASSIGNED
    }
  } */
  isVehicleSelected(vin: string): boolean {

    if (isNullOrUndefined(this.selectedVehicles) || this.selectedVehicles.length == 0) return false;
    return this.selectedVehicles.some(v => v.vin === vin);
  }

  onVehicleSelectionChange(checked: boolean, vehicle: any) {

    var vehicleIndex = this.selectedVehicles.findIndex(v => v.vin === vehicle.vin);

    if (checked && vehicleIndex == -1) {
      this.selectedVehicles.push(vehicle);
    } else if (!checked && vehicleIndex >= 0) {
      this.selectedVehicles.splice(vehicleIndex, 1);
    }
  }

  getPaginatedAccountVehicles(page: number) {
    var requestPayload = this.getVehicleFilters();
    this.utilService.showSpinner();
    this.apiService.getPaginatedAccountVehicles(requestPayload, page, PAGE_SIZE).then((data) => {
      this.utilService.hideSpinner();
      console.log("vehicles response::", data);
      this.processVehicleResponse(data);
      this.backupVehicleList = JSON.parse(JSON.stringify(this.vehicleList));
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getPaginatedAccountVehicles(page);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  private processVehicleResponse(vehicleResponse: any) {
    this.vehicleList = vehicleResponse.vehicles;

    this.vehicleList.forEach(vehicle => {
      vehicle['logo'] = this.getVehicleLogo(vehicle);
    });
    console.log("vehicles ::", this.vehicleList);
    // this.vehiclesMasterData = this.vehicleList.map(x => Object.assign({}, x));
    this.nextPage = vehicleResponse.nextPage;
    this.previousPage = vehicleResponse.prevPage;
  }

  getVehicleFilters() {
    return this.vehicleFilters;
  }

  getPreviousPage() {
    this.getPaginatedAccountVehicles(this.previousPage);
  }

  getNextPage() {
    this.getPaginatedAccountVehicles(this.nextPage);
  }

  getVehicleLogo(vehicle): string {
    return this.vehicleService.getVehicleLogo(vehicle);
  }

  resetEnrollVehicles() {
    this.selectedVehicles = [];
    this.vehicleList = [];
    this.vehicleFilters = [];
    this.selectedPackages = undefined;
    this.searchKey = null;
    console.log("this.selectedVehicles: ", this.selectedVehicles);
  }

  onEnrollVehicles() {
    this.enrollmentErrors = [];
    console.log("this.selectedVehicles: ", this.selectedVehicles);

    var requestPayload = this.getEnrollVehiclesPayload();

    if (requestPayload.packageIds.length == 0) {
      this.toastService.showWarning(MessageConstants.SELECT_AT_LEAST_1_PACKAGE);
      return;
    }

    this.utilService.showSpinner();
    this.apiService.enrollVehicles(requestPayload).then((data) => {
      this.toastService.showSuccess(MessageConstants.VEHICLE_ENROLLMENT_INITIATED);
      this.utilService.hideSpinner();
      console.log("vehicle enrollment response::", data);
      this.logEnrollmentErrors(data);
      this.getPaginatedAccountVehicles(0);
      this.resetEnrollVehicles();
      this.saveEmitter.emit();
      document.getElementById("closeAccountPackages").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.onEnrollVehicles();
        });
      } else {
        this.utilService.hideSpinner();
        this.logEnrollmentErrors(error);
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getSelectedVehicles() {
    let vehicles = this.selectedVehicles.map((vehicle) => vehicle.vin);
    return {
      "vehicles": vehicles
    }
  }

  logEnrollmentErrors(enrollmentResponse) {
    let errors = enrollmentResponse.errorResponse;
    if (isNullOrUndefined(errors)) return;
    console.log("Enrollment Errors: " + errors);
    this.enrollmentErrors = errors;
    document.getElementById("openEnrollmentErrorsModal").click();
  }

  initModalParameters(selectedButton) {
    this.searchKey = null;
    this.getAccountVehicleBrands();

    if (selectedButton == EnrollmentConstants.ENROLL_NOW) {
      this.headerText = "Enroll Vehicles";
      this.buttonText = EnrollmentConstants.ENROLL_NOW;
      this.vehicleFilters = {
        // "enrollmentReady": true,
        // // "status": EnrollmentConstants.INACTIVE,
        // "enrollmentEligibility": true,
        // "enrollmentStatus": "NOT_ENROLLED"
        "enrollmentStatus": EnrollmentConstants.NOT_ENROLLED + "|" + EnrollmentConstants.UNENROLLED + "|" + EnrollmentConstants.ENROLLMENT_FAILED
      };

      this.reviewVehicleModalMessages = {
        header: "Enroll Vehicle(s)",
        message: "Confirm vehicle(s) enrollment?",
        // note: "Once defleeted, data on these VINs are remotely wiped and VINs would no longer be part of the fleet, and cannot be automatically added back to the account."
      };
      this.isEnrollWindow = true;
    } else if (selectedButton == EnrollmentConstants.UNENROLL_NOW) {
      this.headerText = "Unenroll Vehicles";
      this.buttonText = EnrollmentConstants.UNENROLL_NOW;
      this.vehicleFilters = {
        // "enrollmentReady": true,
        // "enrolledForData": true,
        "enrollmentStatus": EnrollmentConstants.ENROLLED + "|" + EnrollmentConstants.ENROLLMENT_CANCELED + "|" + EnrollmentConstants.ENROLLMENT_FAILED + "|" + EnrollmentConstants.ENROLLMENT_INITIATED + "|" + EnrollmentConstants.ENROLLMENT_IN_PROGRESS + "|" + EnrollmentConstants.ENROLLMENT_RETRY + "|" + EnrollmentConstants.UNENROLLMENT_CANCELED + "|" + EnrollmentConstants.UNENROLLMENT_FAILED + "|" + EnrollmentConstants.UNENROLLMENT_RETRY
      };

      this.reviewVehicleModalMessages = {
        header: "Unenroll Vehicle(s)",
        message: "Confirm vehicle(s) unenrollment?",
        // note: "Once defleeted, data on these VINs are remotely wiped and VINs would no longer be part of the fleet, and cannot be automatically added back to the account."
      };
      this.isEnrollWindow = false;
    }

    console.log("initModalParameters - getPaginatedAccountVehicles");
    this.getPaginatedAccountVehicles(0);
  }

  onClick() {
    if (this.buttonText == EnrollmentConstants.ENROLL_NOW) {
      document.getElementById("closeReviewEnrollmentVehicles").click();
      this.accountPackageModal.init();
      document.getElementById("openAccountPackages").click();
    } else if (this.buttonText == EnrollmentConstants.UNENROLL_NOW) {
      this.onUnenrollVehicles();
    }
  }

  onUnenrollVehicles() {
    this.enrollmentErrors = [];
    var requestPayload = this.getSelectedVehicles();
    this.utilService.showSpinner();

    this.apiService.unenrollVehicles(requestPayload).then((data) => {
      this.toastService.showSuccess(MessageConstants.VEHICLE_UNENROLLMENT_INITIATED);
      document.getElementById("closeReviewEnrollmentVehicles").click();
      this.utilService.hideSpinner();
      console.log("vehicle unenrollment response::", data);
      this.logEnrollmentErrors(data);
      this.getPaginatedAccountVehicles(0);
      this.resetEnrollVehicles();
      this.saveEmitter.emit();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.onUnenrollVehicles();
        });
      } else {
        this.utilService.hideSpinner();
        this.logEnrollmentErrors(error);
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onSubmitAccountPackages(selectedPackages) {
    console.log("onSubmitAccountPackages(), selectedPackages: ", selectedPackages);
    this.selectedPackages = selectedPackages;
    this.onEnrollVehicles();
    // document.getElementById("closeEnrollVehicles").click();
  }

  getEnrollVehiclesPayload() {
    let selectedPackageIds = this.selectedPackages.map(selectedPackage => selectedPackage.accountServicePackageId);;
    let vehicles = this.selectedVehicles.map((vehicle) => vehicle.vin);
    return {
      "packageIds": selectedPackageIds,
      "vehicles": vehicles
    }
  }

  onCancelAccountPackages() {
    this.resetEnrollVehicles();
  }

  /**
   * START: Handle the brand filters
   */

  vehicleBrands: Array<any> = []
  vehicleBrandFilters = {
    make: [],
    model: [],
    trim: [],
    year: []
  }

  selectedVehicleBrandFilters = {
    make: null,
    model: null,
    trim: null,
    year: null
  }

  getAccountVehicleBrands() {
    this.resetVehicleBrandFilters();
    this.utilService.showSpinner();
    this.apiService.getAccountVehicleBrands().then((data) => {
      this.utilService.hideSpinner();
      console.log("Account vehicle brands::", data);
      if(!isNullOrUndefined(data)) {
        this.vehicleBrands = data;
        this.initVehicleBrandFilters();
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountVehicleBrands();
        });
      } else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initVehicleBrandFilters() {
    let make: string[] = this.vehicleBrands.map(function (vehicle) { return vehicle['brand']; });
    make = Array.from(new Set(make));
    this.vehicleBrandFilters.make = make;
  }

  handleMakeSelection(make: string) {
    console.log("BEFORE: handleMakeSelection: ", this.selectedVehicleBrandFilters, this.vehicleBrandFilters);
    this.selectedVehicleBrandFilters.model = null;
    this.selectedVehicleBrandFilters.trim = null;
    this.selectedVehicleBrandFilters.year = null;
    this.getModel(make);
    this.vehicleBrandFilters.trim = [];
    this.vehicleBrandFilters.year = [];
    console.log("AFTER: handleMakeSelection: ", this.selectedVehicleBrandFilters, this.vehicleBrandFilters);
    this.callAccountVehicleApi();
  }

  getModel(make: string) {
    let models = [];
    this.vehicleBrands.forEach(vehicle => {
      if(vehicle["brand"] == make) 
        models.push(vehicle['model']);
    });
    models = Array.from(new Set(models)).sort();
    this.vehicleBrandFilters.model = models;
  }

  handleModelSelection(model: string) {
    console.log("BEFORE: handleModelSelection: ", this.selectedVehicleBrandFilters, this.vehicleBrandFilters);
    this.selectedVehicleBrandFilters.trim = null;
    this.selectedVehicleBrandFilters.year = null;
    this.vehicleBrandFilters.year = [];
    this.getTrims(model);
    console.log("AFTER: handleModelSelection: ", this.selectedVehicleBrandFilters, this.vehicleBrandFilters);
    this.callAccountVehicleApi();
  }

  getTrims(model: string) {
    let trims = [];
    this.vehicleBrands.forEach(vehicle => {
      if (vehicle["brand"] == this.selectedVehicleBrandFilters.make && vehicle["model"] == model && vehicle["trim"])
        trims.push(vehicle["trim"]);
    });

    if(trims && trims.length > 0) {
      trims = Array.from(new Set(trims)).sort();
      this.vehicleBrandFilters.trim = trims;
    } else {
      this.getModelYears(model);
    }
  }

  handleTrimSelection(trim: string) {
    console.log("BEFORE: handleTrimSelection: ", this.selectedVehicleBrandFilters, this.vehicleBrandFilters);
    this.selectedVehicleBrandFilters.year = null;
    this.getTrimYears(trim);
    console.log("AFTER: handleTrimSelection: ", this.selectedVehicleBrandFilters, this.vehicleBrandFilters);
    this.callAccountVehicleApi();
  }

  getModelYears(model: string) {
    let years = [];
    this.vehicleBrands.forEach(vehicle => {
      if (vehicle["brand"] == this.selectedVehicleBrandFilters.make && vehicle["model"] == model)
        years.push(vehicle["year"]);
    });
    years = Array.from(new Set(years)).sort();
    this.vehicleBrandFilters.year = years;
  }

  getTrimYears(trim: string) {
    let years = [];
    this.vehicleBrands.forEach(vehicle => {
      if (vehicle["brand"] == this.selectedVehicleBrandFilters.make 
        && vehicle["model"] == this.selectedVehicleBrandFilters.model
        && vehicle["trim"] == trim)
        years.push(vehicle["year"]);
    });
    years = Array.from(new Set(years)).sort();
    this.vehicleBrandFilters.year = years;
  }

  handleYearSelection(year: number) {
    console.log("BEFORE: handleYearSelection: ", this.selectedVehicleBrandFilters, this.vehicleBrandFilters);
    console.log("year selected:", year);
    console.log("AFTER: handleYearSelection: ", this.selectedVehicleBrandFilters, this.vehicleBrandFilters);
    this.callAccountVehicleApi();
  }

  callAccountVehicleApi() {
    this.vehicleFilters['make'] = this.selectedVehicleBrandFilters.make;
    this.vehicleFilters['model'] = this.selectedVehicleBrandFilters.model;
    this.vehicleFilters['trim'] = this.selectedVehicleBrandFilters.trim;
    this.vehicleFilters['year'] = this.selectedVehicleBrandFilters.year;
    this.getPaginatedAccountVehicles(0);
  }

  resetVehicleBrandFilters() {
    this.vehicleBrands = [];
    this.vehicleBrandFilters = {
      make: [],
      model: [],
      trim: [],
      year: []
    }

    this.selectedVehicleBrandFilters = {
      make: null,
      model: null,
      trim: null,
      year: null
    }
  }

  /**
   * END: Handle the brand filters
   */

  onVehicleSelection() {
    if (this.selectedVehicles.length == 0) {
      this.toastService.showWarning(MessageConstants.SELECT_AT_LEAST_1_VEHICLE);
      return;
    }
    document.getElementById("closeEnrollVehicles").click();
    document.getElementById("openReviewEnrollmentVehicles").click();
  }

  reviewVehiclesSubmit() {
    console.log("Reviewd vehicles::", this.selectedVehicles);
    this.onClick();
  }

  removeSelectedVehicle(vehicleIndex) {
    if (this.selectedVehicles.length > 1) {
      this.selectedVehicles.splice(vehicleIndex, 1);
    }
    console.log("selected vehicles: ", this.selectedVehicles);
  }

  backReviewEnrollmentVehicles() {
    console.log("backReviewEnrollmentVehicles()::Selected vehicles::", this.selectedVehicles);
    document.getElementById("closeReviewEnrollmentVehicles").click();
    document.getElementById("openEnrollVehicles").click();
  }

  backAccountPackages() {
    document.getElementById("closeAccountPackages").click();
    document.getElementById("openReviewEnrollmentVehicles").click();
  }

  searchClicked() {
    console.log("search clicked!");
    if (this.searchKey == undefined || this.searchKey == null || this.searchKey.trim().length <= 0) return;

    this.selectedVehicles = [];
    var payload = {
      "scope": "VEHICLES",
      "searchKey": this.searchKey.trim(),
      "filters": {
        "accountId": this.account.id
      }
    };
    this.search(payload);
  }

  search(payload: any) {
    this.utilService.showSpinner();
    this.apiService.searchData(payload).then((data) => {
      this.utilService.hideSpinner();
      console.log("search result ::", data);
      if (!data || data.length == 0) {
        this.toastService.showError(Constants.SEARCH_RESULT_NOT_FOUND);
      } else {
        var searchedData = data[0].results;
        if (!searchedData || searchedData.length == 0) {
          this.toastService.showError(Constants.SEARCH_RESULT_NOT_FOUND);
        } else {
          console.log("Vehicle list before search: ", this.vehicleList);
          this.vehicleList = [];
          searchedData.forEach(element => {
            element['logo'] = this.getVehicleLogo(element);
            if (element.account) {
              element['accountId'] = element.account.id;
            }
            
            if (element.status != Constants.DELETED) {
              this.vehicleList.push(element);
            } else {
              this.toastService.showError(Constants.SEARCH_RESULT_NOT_FOUND);
            }
          });
          console.log("Vehicle list after search: ", this.vehicleList);
        }
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.search(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetSearch() {
    this.searchKey = null;
    this.selectedVehicles = [];
    this.vehicleList = JSON.parse(JSON.stringify(this.backupVehicleList));
  }

  getVehicleEnrollmentStatus(vehicle: any): string {
    return this.utilService.getVehicleEnrollmentStatus(vehicle);
  }
}